import { RoutingMap } from '@app/entities';
import { getAuthToken, getLocationParts, withAuthHandoff } from '@common';
import { selectAuthUser } from '@pages/Authentication/store/selectors';
import { MenuProps } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function useHeader() {
    const navigate = useNavigate();
    const user = useSelector(selectAuthUser);
    const authToken = getAuthToken();

    const { subdomain, maindomain } = getLocationParts();

    const onClick: MenuProps['onClick'] = e => {
        if (subdomain) {
            window.location.href = withAuthHandoff(`${window.location.protocol}//${maindomain}${e?.key}`, authToken);
        } else {
            navigate(`${e?.key}`);
        }
    };

    const menu = user ? PrivateMenuItems : PublicMenuItems;
    return { menu, onClick };
}

export const PublicMenuItems = [RoutingMap.Home, RoutingMap.Cli, RoutingMap.Analytcis, RoutingMap.About];

export const PrivateMenuItems = [
    RoutingMap.Home,
    RoutingMap.NewProject,
    RoutingMap.Cli,
    RoutingMap.Analytcis,
    RoutingMap.About,
];
